import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import api from '../middleware/api'
import rootReducer from '../reducers';

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk)
    );
}



// WEBPACK FOOTER //
// ./src/client/store/configureStore.prod.js